import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { Layout, Button, Input, Select } from "element-react";
require("./index.scss");

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  componentDidMount = () => {

  }

  render() {
    return (
      <div className="preferential-server">
       <div className="ps-head">
         <div className="title">优惠服务</div>
       </div>
       <div className="ps-main">
        <div className="box">
          <div className="b-bg bg1"></div>
          <div className="b-title">退役军人免费体检</div>
          <div className="b-subtitle">血糖、血压监测</div>
          <div className="b-free">免费</div>
          <div className="b-btn">立即报名</div>
        </div>
        <div className="box">
          <div className="b-bg bg1"></div>
          <div className="b-title">退役军人免费体检</div>
          <div className="b-subtitle">血糖、血压监测</div>
          <div className="b-free">免费</div>
          <div className="b-btn">立即报名</div>
        </div>
        <div className="box">
          <div className="b-bg bg1"></div>
          <div className="b-title">退役军人免费体检</div>
          <div className="b-subtitle">血糖、血压监测</div>
          <div className="b-free">免费</div>
          <div className="b-btn">立即报名</div>
        </div>
        <div className="box">
          <div className="b-bg bg1"></div>
          <div className="b-title">退役军人免费体检</div>
          <div className="b-subtitle">血糖、血压监测</div>
          <div className="b-free">免费</div>
          <div className="b-btn">立即报名</div>
        </div>
        <div className="box">
          <div className="b-bg bg1"></div>
          <div className="b-title">退役军人免费体检</div>
          <div className="b-subtitle">血糖、血压监测</div>
          <div className="b-free">免费</div>
          <div className="b-btn">立即报名</div>
        </div>
        <div className="box">
          <div className="b-bg bg1"></div>
          <div className="b-title">退役军人免费体检</div>
          <div className="b-subtitle">血糖、血压监测</div>
          <div className="b-free">免费</div>
          <div className="b-btn">立即报名</div>
        </div>
       </div>
      </div>
    );
  }
}
